"use client" // Error components must be Client Components

import { Image, Text, Title } from "@mantine/core"
import { IconHome } from "@tabler/icons-react"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

import { BlueButton } from "@/components/generic/BlueButton"
import { cn } from "@/lib/utils"
import Link from "next/link"

export default function NotFound() {
  const pathname = usePathname()
  useEffect(() => {
    document.title = "Page not found! - Ring.io"
    // Log the error to an error reporting service
    console.error(`Page not found: ${pathname}`)
  }, [pathname])

  return (
    <div
      className={cn(
        "flex h-screen w-screen flex-col items-center justify-center"
      )}
    >
      <div className="relative -mt-28 flex min-h-[650px] min-w-[864px] flex-row items-end justify-center">
        <Title className="absolute z-0 !text-[500px] text-gray-200">404</Title>
        <Image
          alt="Not Found Logo"
          h={300}
          w="auto"
          fit="contain"
          src="/assets/error_404.gif"
          className="relative z-10 h-[300px] pb-8"
        />
      </div>
      <div className="z-10 mt-[-50px] flex flex-col items-center justify-center gap-1">
        <Title order={3} className="w-full text-center">
          Looks like you&apos;re lost!
        </Title>
        <Text className="px-12 text-center" maw={560}>
          The page you are looking for does not exist. How you got here is a
          mystery. But you can click the button below to go back to the
          homepage.
        </Text>
        <BlueButton
          size={"md"}
          leftSection={<IconHome className="size-4" />}
          component={Link}
          href="/"
          className="mt-2"
        >
          Go home
        </BlueButton>
      </div>
    </div>
  )
}
